import { useGetCorePatients } from 'infrastructure/hooks/patient/use-get-core-patients';
import { generateFullName } from 'utils/badgeHelpers';
import { ClinicStatus } from 'infrastructure/enums';

import type { TQueryProps } from 'infrastructure/hooks/patient/use-get-core-patients';
import type {
  ICorePatientsResponse,
  IRpmOnboardingStatusReportFilters,
} from 'infrastructure/interfaces';

const clinicStatus = [ClinicStatus.Active, ClinicStatus.Delinquent];

const prepareData = (data?: ICorePatientsResponse) => {
  return {
    patients: data?.items?.map((item) => ({
      guid: item.guid,
      name: `${item.firstName} ${item.lastName}`,
      mrn: item.mrn,
      dob: item.birthDate,
      phone: item.phone,
      state: item.state,
      insType: item.insurances.length ? item.insurances[0].type : null,
      clinic: item.clinic,
      primaryDoctor:
        item.primaryDoctor &&
        generateFullName(
          item.primaryDoctor.title,
          item.primaryDoctor.firstName,
          null,
          item.primaryDoctor.lastName,
        ),
      insProvider: item.insurances.length
        ? item.insurances.map((insurance) => insurance.provider).join(',\n')
        : null,
      insNumber: item.insurances.length
        ? item.insurances.map((insurance) => insurance.number).join(',\n')
        : null,
      fulfillment: item.status,
      practiceEmail: item.primaryDoctor.email,
      createdAt: item?.createdAt,
    })),
    patientCount: data?.count,
  };
};

export const useOnboardingStatusReport = ({
  patientGuid,
  ...props
}: IRpmOnboardingStatusReportFilters) => {
  const filter: TQueryProps = {
    ...props,
    clinicGuid: props.clinicGuid?.join(','),
    clinicsStatus: clinicStatus.join(','),
    status: props.status ?? 'only_onboarding_flow',
    doctorGuid: props.doctorGuid?.join(','),
    guid: patientGuid,
  };

  const { data, isLoading, isFetching } = useGetCorePatients(filter);

  return {
    patients: prepareData(data),
    patientsLoading: isLoading || isFetching,
  };
};
